import _forEach from 'lodash/forEach';
import _isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';

export default class LoginUtils {
  /**
   * Generates the next path object based on the provided query and parameter for redirection.
   * @param {Object} parameters - The parameters object.
   * @param {Object} parameters.query - The query object containing key-value pairs.
   * @param {string} parameters.parameterThatGetsPathForRedirection - The parameter used for redirection.
   * @param {string[]} [parameters.parametersToRemove=[]] - The parameters to remove from the query.
   * @returns {Object} - The next path object describing next URL to redirect the user.
   */
  static generateNextPathFromUrl({ query, parameterThatGetsPathForRedirection, parametersToRemove = [] }) {
    const newQuery = parametersToRemove.reduce((tempQuery, param) => {
      const { [param]: omitted, ...rest } = tempQuery;
      return rest;
    }, query);

    const newQueryString = queryString.stringify(newQuery, { encode: true });

    // History : remove /app for url starting with /app
    let newPathname = query[parameterThatGetsPathForRedirection];
    if (typeof newPathname === 'string' && (newPathname.startsWith('app') || newPathname.startsWith('/app'))) {
      newPathname = newPathname.replace('/app', '');
      newPathname = newPathname.replace('app', '');
    }

    const newParameters = _isEmpty(newQueryString) ? '' : `?${newQueryString}`;

    const pathToRedirect = {
      pathname: newPathname,
      search: newParameters,
    };
    return pathToRedirect;
  }

  /**
   * Parses the available paths to find the first allowed path based on provided context and permission check.
   * @param {Object[]} parameters - The parameters object.
   * @param {Object[]} parameters.availablePaths - The array of available paths objects.
   * @param {*} parameters.context - The context or permissions against which to check.
   * @param {Function} parameters.hasPermission - The function to check if the user has permission.
   * @returns {Object|undefined} - The first allowed path object, or undefined if none is found.
   */

  static parseAvailablePathsToFindTheFirstAllowed({ availablePaths, context, hasPermission }) {
    let pathToRedirect;
    _forEach(availablePaths, (pathObj) => {
      const { path, permission } = pathObj;
      if (
        !permission
          || hasPermission({
            needed: permission,
            permissionsOrContext: context,
          })
      ) {
        pathToRedirect = {
          pathname: path,
        };
        return false;
      }
    });

    return pathToRedirect;
  }
}



// WEBPACK FOOTER //
// ./utils/LoginUtils.js